<template>
  <teleport to="#dialogs">
    <agentforce-chat
      :config="chatConfig"
      :user-name="userStore.details?.firstName"
      v-on="handlers"
    />
  </teleport>
  <div
    v-show="showChatLauncher && !isChatOpen"
    class="fixed bottom-0 right-0 z-above-header mr-6"
    :class="fabOffsetClass"
    data-test-id="chat-fab"
  >
    <base-button
      aria-label="Open chat"
      class="group h-14 min-w-14 flex center overflow-hidden ws-nowrap rounded-full px-4 c-white shadow-lg ease-in-out duration-400 active:scale-96 hover:px-6"
      style="background: linear-gradient(140deg, #183528 11%, #395a4b 111%)"
      @click="$chat.open({ eventLabel: $t.agentforce.launcherText, buttonLocation: 'floating-side-bar' })"
    >
      <vf-icon
        class="transform c-white transition-transform ease-in-out duration group-hover:rotate-360"
        name="sparkle"
        :size="{ sm: 'md' }"
      />
      <span class="ml-0 max-w-0 transform overflow-hidden text-sm op-0 transition-all ease-in-out duration group-hover:ml-2 group-hover:max-w-72 group-hover:op-100">
        {{ $t.agentforce.launcherText }}
      </span>
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import { AgentforceChat, useAgentforceChat } from '@vfc/agentforce-chat'
import '@vfc/agentforce-chat/style.css'

const { $chat, $feature } = useNuxtApp()
const route = useRoute()
const showChatLauncher = $feature.enableSfccAgentforceChat
const fabOffsetClass = computed(() => {
  const name = isString(route.name) ? route.name : ''
  if (name === 'cart') return 'mb-21'
  if (name === 'p-slug') return 'mb-20'
  return 'mb-4'
})

const {
  chatConfig,
  chatWidth,
  handlers,
  isChatOpen,
  isDesktop,
  userStore,
} = useAgentforceHostBindings()

const { open, close, isReady } = useAgentforceChat()

watch(isReady, (ready) => {
  if (ready && isChatOpen.value) open()
})

watch(isChatOpen, (val) => {
  if (!isReady.value) return
  if (val) open()
  else close()
})

useHead(() => ({
  bodyAttrs: {
    class: isChatOpen.value && isDesktop.value
      ? 'af-chat-push af-chat-push-open'
      : 'af-chat-push',
    style: isChatOpen.value && isDesktop.value
      ? `--chat-width: ${chatWidth.value}px;`
      : '',
  },
}))
</script>
